export type RovingOrientation = "horizontal" | "vertical" | "both";

export function rovingIndex(key: string, current: number, length: number, orientation: RovingOrientation = "both"): number {
  if (length === 0) return -1;

  const forward = orientation === "vertical" ? ["ArrowDown"] : orientation === "horizontal" ? ["ArrowRight"] : ["ArrowRight", "ArrowDown"];
  const backward = orientation === "vertical" ? ["ArrowUp"] : orientation === "horizontal" ? ["ArrowLeft"] : ["ArrowLeft", "ArrowUp"];

  if (forward.includes(key)) return (current + 1) % length;
  if (backward.includes(key)) return (current - 1 + length) % length;
  if (key === "Home") return 0;
  if (key === "End") return length - 1;

  return -1;
}
